<template>
  <div
    :class="['attribute-display-container', { 'hasSimpleValues': hasSimpleValues }, { 'hasAxiomeLogique': hasAxiomeLogique }, { 'hasAxiomeAnonymes': hasAxiomeAnonymes }]">
    <!--  Affichage  du prédicat + langage selector (optionel) -->
    <div>
      <div class="d-flex justify-content-start" style="align-items: baseline;">
        <div class="item tooltip-label-container">
          <TooltipLabel :title="title" :label="label" :negative="negative" />
        </div>
        <div class="item" v-if="isOnlyNotLocalizedLang" style="display: flex;">
          <AttributeLanguageSelector :blankNodes="blankNodes" :simpleValues="simpleValues" />
        </div>
      </div>
    </div>

    <!--  Affichage  du noeud-->
    <SmtAccordion :parentKey="label" :accordion="accordion" :simpleValues="valuesToUse" :blankNodes="blankNodes"
      :accordiontDisplayOpen="accordiontDisplayOpen">

      <PropertyValue :values="valuesToUse" :treeDisplay="hasBlanknodes" :showLanguageBadge="showLanguageBadge"
        :predicat="label" :level0="true" />

      <!--  Affichage  des blankNodes -->
      <template v-if="blankNodes.length">
        <AttributeBlankNode :blankNodes="blankNodes" :showLanguageBadge="showLanguageBadge" :parentKey="label"
          :parentNode="label" :braceDisplay="false" :level0="true" />
      </template>
    </SmtAccordion>

  </div>
</template>

<script>
import ConceptsStore from "../../concepts-store";
import StoreConfiguration from "../../store-configuration";
import BASIC_ATTRIBUTES from "../../enums/basic_attributes";
import Utils from "../../utils";

export default {
  name: "AttributeDisplay",

  props: {
    languages: {
      type: Array,
      default: () => [],
    },
    uri: String,
    values: {
      type: Array,
      default: () => [],
    },
    litterals: {
      type: Array,
      default: () => [],
    },
    blankNodes: {
      type: Array,
      default: () => [],
    },
    multilingualValues: Object,
    title: String,
    label: String,
    negative: {
      type: Boolean,
      default: false,
    },
    accordion: {
      type: Boolean,
      default: false,
    },
    accordiontDisplayOpen: {
      type: Boolean,
      default: false,
    },
    // ...existing code...
    order: Number,
  },

  data() {
    return {
      store: ConceptsStore.state,
      lang: this.$route.query.lang,
      storeConfiguration: StoreConfiguration.state,
      basicAttributes: {
        "array": Object.values(BASIC_ATTRIBUTES),
        "object": BASIC_ATTRIBUTES,
      },
      localLanguages: [],
      isOnlyNotLocalizedLang: false
    }
  },

  created() {
    if (this.values === undefined) {
      this.values = {};
    }
    let data = [];
    data = data.concat(this.values || []).concat(this.litterals || []).concat(this.multilingualValues || []);
    const { languages, isOnlyNotLocalizedLang } = Utils.processLanguages(this.blankNodes, this.storeConfiguration, data);
    this.localLanguages = languages;
    this.isOnlyNotLocalizedLang = isOnlyNotLocalizedLang;
  },

  computed: {
    simpleValues() {
      let data = [];
      data = data.concat(this.values || []).concat(this.litterals || []).concat(this.multilingualValues || []);
      return data
    },
    showLanguageBadge() {
      return this.localLanguages.length > 0;
    },
    hasBlanknodes() {
      return this.blankNodes.length > 0;
    },
    numberValeurInAccordeon() {
      return this.values.length;
    },
    hasSimpleValues() {
      return this.simpleValues.length > 0;
    },
    hasAxiomeLogique() {
      return this.blankNodes.some(blankNode => blankNode.blankNodeType === 'LOGICAL_AXIOM');
    },
    hasAxiomeAnonymes() {
      return this.blankNodes.some(blankNode => blankNode.blankNodeType === 'ANONYMOUS_ANNOTATION');
    },

    /**
     * Récupère les valeurs à utiliser pour l'affichage selon si c'est du litterals/multilingualValues etc...
     */
    valuesToUse() {
      let valuesToUse = [];
      if (this.litterals && this.litterals.length > 0) {
        valuesToUse.push(...this.litterals);
      }
      if (this.multilingualValues && this.multilingualValues.length > 0) {
        valuesToUse.push(...this.multilingualValues);
      }
      if (this.values && this.values.length > 0) {
        valuesToUse.push(...this.values);
      }
      return valuesToUse;
    },

    style() {
      let style = '';
      if (this.order) {
        style += 'order:' + this.order + ';';
      }
      return style;
    }
  },

  methods: {
    getStyleFromConfiguration(attribute) {
      return this.getAttributeOrder(attribute) + this.getAttributeVisibility(attribute);
    },

    getAttributeVisibility(attribute) {
      if (
        this.storeConfiguration.current?.concepts_details?.attributs?.masques
        && Object.keys(this.storeConfiguration.current.concepts_details.attributs.masques).length
      ) {
        let basicUri = BASIC_ATTRIBUTES[attribute] ? BASIC_ATTRIBUTES[attribute] : ' ';

        if (
          Object.values(this.storeConfiguration.current?.concepts_details?.attributs?.masques).indexOf(attribute) > -1
          || Object.values(this.storeConfiguration.current?.concepts_details?.attributs?.masques).indexOf(basicUri) > -1
        ) {
          return 'display: none;';
        }
      }

      return "";
    },
    getAttributeOrder(attribute) {
      if (
        this.storeConfiguration.current?.concepts_details?.attributs?.ordre
        && this.storeConfiguration.current.concepts_details.attributs.ordre.length
      ) {
        let basicUri = BASIC_ATTRIBUTES[attribute] ? BASIC_ATTRIBUTES[attribute] : ' ';

        let attributsUriOrdered = this.storeConfiguration.current?.concepts_details?.attributs?.ordre.map(attribut => attribut.uri);
        if (attributsUriOrdered.indexOf(attribute) > -1) {
          return 'order:' + attributsUriOrdered.indexOf(attribute) + ';';
        } else if (attributsUriOrdered.indexOf(basicUri) > -1) {
          return 'order:' + attributsUriOrdered.indexOf(basicUri) + ';';
        }

        return 'order:' + (attributsUriOrdered.length + 1) + ';';
      }

      return "";
    },
  }
}
</script>


<style lang="scss" scoped>
.tooltip-label-container {
  padding-right: 15px;
  padding-top: 15px;
}
</style>
